import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setVersions, setSongs } from '@state/actions/songs'
import { useVersions } from '@state/uses/songs'
import { useDanceOnAddProcess } from '@state/uses/dances'
import { setDanceOnAddProcess } from '@state/actions/dances'
import api from '@services/api'
import acum from '@services/acum'
import PaginatedTable from '@components/Table/PaginatedTable'
import { TableButton } from '@appearance/styled'
import MessageModal from '@components/Modals/MessageModal'
import i18n from '@localization/i18n'

export default ({ songId }) => {
    const [errorModalIsOpen, setErrorModalIsOpen] = useState(false)
    const [versionsFromApi, setVersionsFromApi] = useState(null)
    const [totalVersions, setTotalVersions] = useState(0)
    useEffect(() => {
        setVersions(null)
        if (versionsFromApi) {
            dispatch(setVersions(versionsFromApi))
        }
    }, [versionsFromApi])

    const columns = [
        {
            property: 'version_number',
            label: i18n.t('akum_results_table.version_number'),
            minWidth: '80px',
        },
        {
            property: 'performer',
            subProperty: 'heb_name',
            label: i18n.t('akum_results_table.performer'),
            minWidth: '80px',
        },
        {
            property: 'publication_date',
            label: i18n.t('akum_results_table.publication_date'),
        },
        {
            property: 'chooseVersion',
            label: '',
            dataScope: 'col',
            align: 'start',
            minWidth: '80px',
            cell: (ver) => {
                return (
                    <TableButton onClick={() => checkIfSongIsTaken(ver)}>
                        {i18n.t('akum_results_table.choose_version')}
                    </TableButton>
                )
            },
        },
    ]
    const history = useHistory()
    const dispatch = useDispatch()
    const danceOnAddProcess = useDanceOnAddProcess()

    useEffect(() => {
        if (!danceOnAddProcess) {
            history.goBack()
        }
    }, [danceOnAddProcess])

    const searchByIdCallback = (total) => setTotalVersions(total)
    const searchById = (page) => {
        return (dispatch) => {
            acum.searchById(songId, page, searchByIdCallback).then(
                (res) => {
                    res !== versionsFromApi && setVersionsFromApi(res)
                },
                (error) =>
                    (!versionsFromApi || versionsFromApi.length > 0) &&
                    setVersionsFromApi([])
            )
        }
    }
    const checkIfSongIsTaken = (ver) => {
        api.getDanceByAkumId(ver.id).subscribe(
            (res) => {
                setErrorModalIsOpen(true)
            },
            (error) => {
                console.log('getDanceByAkumId error', error)
                chooseVersion(ver)
            }
        )
    }

    const chooseVersion = (ver) => {
        danceOnAddProcess.performer = ver.performer.heb_name
        const translatedSongName = ver.work_eng_name
            ? ` - ${ver.work_eng_name}`
            : null
        danceOnAddProcess.song = Object.assign({}, danceOnAddProcess.song, {
            name: translatedSongName
                ? ver.work_heb_name + translatedSongName
                : ver.work_heb_name,
            akum_id: ver.id?.length === 9 ? ver.id.substring(0, 6) : ver.id,
            publication_year: ver.publication_date,
            lyricists: ver.lyricists,
            composers: ver.composers,
        })
        dispatch(setDanceOnAddProcess(danceOnAddProcess))
        dispatch(setSongs(null))
        dispatch(setVersions(null))
        history.push({
            pathname: 'dance',
        })
    }

    return (
        <Container>
            <MessageModal
                isOpen={errorModalIsOpen}
                title={i18n.t('modals.error')}
                mainText={i18n.t('akum_results_table.dance_alreay_exists')}
                onClose={() => setErrorModalIsOpen(false)}
                error
            />
            <PaginatedTable
                title={i18n.t('akum_results_table.songs')}
                columns={columns}
                useFunction={useVersions}
                loadAction={searchById}
                hidePageSize
                hideTableHeader
                totalItems={totalVersions}
            />
        </Container>
    )
}

const Container = styled.div``
